module.exports = __webpack_public_path__ + "img/主营业务_软件产品中心06.e91a37be.png";